var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4164 6.2316C17.417 6.12741 17.397 6.02413 17.3576 5.92767C17.3182 5.83122 17.2601 5.74349 17.1868 5.66952L13.8301 2.31285C13.7561 2.23948 13.6684 2.18143 13.5719 2.14203C13.4755 2.10263 13.3722 2.08266 13.268 2.08327C13.1638 2.08266 13.0605 2.10263 12.9641 2.14203C12.8676 2.18143 12.7799 2.23948 12.7059 2.31285L10.4655 4.55326L1.8126 13.2062C1.73923 13.2802 1.68118 13.3679 1.64179 13.4643C1.60239 13.5608 1.58242 13.6641 1.58302 13.7683V17.1249C1.58302 17.3349 1.66643 17.5363 1.81489 17.6847C1.96336 17.8332 2.16472 17.9166 2.37469 17.9166H5.73135C5.84213 17.9226 5.95294 17.9053 6.05659 17.8657C6.16024 17.8262 6.25442 17.7653 6.33302 17.687L14.9384 9.0341L17.1868 6.83326C17.259 6.75654 17.3179 6.66823 17.3609 6.57201C17.3686 6.50891 17.3686 6.44512 17.3609 6.38201C17.3646 6.34516 17.3646 6.30803 17.3609 6.27118L17.4164 6.2316ZM5.40677 16.3333H3.16635V14.0928L11.0276 6.2316L13.268 8.47201L5.40677 16.3333ZM14.3843 7.35576L12.1439 5.11535L13.268 3.9991L15.5005 6.2316L14.3843 7.35576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSmall);
export default __webpack_public_path__ + "static/media/pencilSmall.f7ca8b9106c983f5b97bd74963d45eea.svg";
export { ForwardRef as ReactComponent };